import {Card} from 'platform/components';
import {Grid} from 'platform/foundation';

interface LeasingParameterSectionProps {
  title: string;
  children: React.ReactNode;
}

/** One titled group of the common leasing parameters, laid out on the shared responsive grid. */
export function LeasingParameterSection(props: LeasingParameterSectionProps) {
  return (
    <Card title={props.title} variant="inlineWhite">
      <Grid columns={[1, 2, 4]}>{props.children}</Grid>
    </Card>
  );
}
